(function () {
  const megaItems = document.querySelectorAll("[data-custom-mega-menu] .custom-mega-menu__item, [data-custom-mega-menu] .mega-menu");
  megaItems.forEach((item) => {
    const details = item.tagName === "DETAILS" ? item : item.querySelector("details");
    if (!details) return;
    let timer;
    item.addEventListener("mouseenter", () => {
      clearTimeout(timer);
      details.setAttribute("open", "");
    });
    item.addEventListener("mouseleave", () => {
      timer = setTimeout(() => details.removeAttribute("open"), 140);
    });
  });

  const sticky = document.querySelector("[data-sticky-atc]");
  const buy = document.querySelector('button[name="add"], .product-form__submit');
  if (sticky && buy) {
    const onScroll = () => {
      const rect = buy.getBoundingClientRect();
      sticky.hidden = rect.bottom > 0 && rect.top < window.innerHeight;
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    const trigger = sticky.querySelector(".custom-sticky-atc__button");
    if (trigger) {
      trigger.addEventListener("click", (event) => {
        event.preventDefault();
        buy.click();
      });
    }
  }

  const form = document.querySelector("[data-compare-form]");
  const table = document.querySelector("[data-compare-table]");
  const open = document.querySelector("[data-compare-open]");
  if (form && table && open) {
    form.addEventListener("change", () => {
      const checked = form.querySelectorAll("[data-compare-toggle]:checked");
      if (checked.length > 3) checked[checked.length - 1].checked = false;
    });
    open.addEventListener("click", () => {
      const cards = [...form.querySelectorAll("[data-compare-toggle]:checked")].map((input) => input.closest("li"));
      if (!cards.length) return;
      table.hidden = false;
      table.innerHTML = cards
        .map((card) => `<div class="custom-compare__picked">${card ? card.innerHTML : ""}</div>`)
        .join("");
    });
  }
})();
